import { GetServerSidePropsContext } from 'next'

export function redirectDocumentUrl(
  ctx: GetServerSidePropsContext,
  documentUrl: string
): { destination: string; permanent: boolean } | null {
  const host = ctx.req.headers.host || 'www.jusbrasil.com.br'
  const url = new URL(ctx.resolvedUrl, `https://${host}`)
  const expectedUrl = new URL(documentUrl)

  const isProductionOrTestEnv =
    (process.env.NODE_ENV === 'production' && !host.endsWith('staging.jusbrasil.com.br')) ||
    process.env.NODE_ENV === 'test'
  if (
    url.pathname !== expectedUrl.pathname ||
    (isProductionOrTestEnv && url.hostname !== expectedUrl.hostname)
  ) {
    const fromUrl = url.toString()
    expectedUrl.search = url.search
    if (!isProductionOrTestEnv) {
      expectedUrl.hostname = url.hostname
    }
    const toUrl = expectedUrl.toString()
    console.log(`redirecting from ${fromUrl} to ${toUrl}`)

    return {
      destination: toUrl,
      permanent: true,
    }
  }

  return null
}
